import Toggle from '@/components/ui/Toggle.tsx';
import { ChangeEditAvailabilityVm } from './editAvailability';

interface EditModeToggleProps {
  isEditing: boolean;
  onToggle: (isEditing: boolean) => void;
  /**
   * Dostępność edycji. Paczka czekająca na decyzję klienta wyłącza przełącznik
   * i tłumaczy powód w dymku — ten sam warunek czyta belka szkicu, więc oba
   * biorą go z jednego miejsca.
   */
  availability?: ChangeEditAvailabilityVm;
}

/** Przełącznik trybu edycji w nagłówku ekranu — wspólny dla trzech ekranów. */
const EditModeToggle = ({
  isEditing,
  onToggle,
  availability,
}: EditModeToggleProps) => (
  <Toggle
    label="Tryb edycji"
    size="md"
    checked={isEditing}
    disabled={availability?.canEdit === false}
    title={availability?.reason}
    onCheckedChange={onToggle}
  />
);

export default EditModeToggle;
